import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card, CardBody, FormGroup, Label, Input, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFormValues, change } from 'redux-form';
import * as submissionFormActions from 'actions/submissionFormActions';
import * as currentUserActions from 'actions/currentUserActions';
import * as finalWizardActions from 'actions/finalWizardActions';
import * as snapSellWizardActions from 'actions/snapSellWizardActions';
import actionTypes from 'constants/currentUserConstants';

class AccountForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    currentUser: ImmutablePropTypes.map.isRequired,
    submitForm: PropTypes.func.isRequired,
    goToFinalStep: PropTypes.func.isRequired,
    goToNextSnapSellStep: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    formIsLoading: PropTypes.bool.isRequired,
  };

  state = {
    validPhoneNumber: true,
  };

  onInputChange = e => this.props.dispatch(change('eventSubmission', e.target.name, e.target.value));
  onCancel = () => this.props.goToFinalStep("email");

  validatePhoneNumber = (number) => {
    const pattern = new RegExp(/^$|^(\(|\)|\d|\-|\s|\+)+$/);
    return pattern.test(number);
  }

  submitForm = event => {
    event.preventDefault();
    const { formValues: { telephone_number} } = this.props;
    const valid = this.validatePhoneNumber(telephone_number);
    this.setState({ validPhoneNumber: valid });
    if (!valid) return;

    if (this.props.snapSell) {
      this.props.goToNextSnapSellStep();
    } else {
      this.props.submitForm('preview', this.props.history, true);
    }
  };


  render() {
    const { formValues, currentUser, formIsLoading, snapSell } = this.props;
    const isLoading = formIsLoading || currentUser.get('isLoading');
    const prompt = snapSell ? "proceed with checkout" : "click 'create account'";

    return (
      <Card>
        <div className="card-header">
          <h4>Welcome to evvnt!</h4>
        </div>
        <CardBody>
          <p>
            Great, lets create an account for <strong>{formValues.email}</strong>.
          </p>
          <p>
            Enter your name, phone number and when you {prompt}, we'll send you a confirmation email
          </p>
          <form onSubmit={this.submitForm}>
            <fieldset>
              <FormGroup>
                <Label>Name *</Label>
                <Input
                  placeholder="Your Name"
                  name="name"
                  value={formValues.name || ''}
                  onChange={this.onInputChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Phone Number *</Label>
                <Input
                  placeholder="Your Phone Number"
                  name="telephone_number"
                  value={formValues.telephone_number || ''}
                  onChange={this.onInputChange}
                />
                {!this.state.validPhoneNumber && <p className="text-danger">Please enter a valid phone number</p>}
              </FormGroup>
              <Button disabled={isLoading || !formValues.name || !formValues.telephone_number} block color="primary">
                {isLoading ? 'Please wait...' : snapSell ? 'Buy now' : 'Create account'}
              </Button>
            </fieldset>
          </form>
        </CardBody>
        <div className="row">
          <div className="col-12 text-right">
            <Button onClick={this.onCancel} color="link">Cancel</Button>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  formIsLoading: state.submissionForm.get('isLoading'),
  formValues: getFormValues('eventSubmission')(state),
  currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
  ...bindActionCreators(currentUserActions, dispatch),
  ...bindActionCreators(finalWizardActions, dispatch),
  ...bindActionCreators(snapSellWizardActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/final/AccountForm.jsx